import createReactComponent from '../createReactComponent';
export default createReactComponent('question', 'Question', [["path",{"d":"M12 21v-.5m0-3c0-5.1 5-3.825 5-8.924 0-6.768-10-6.768-10 0","key":"svg-0"}]]);